<template>
    <div class="header" :class="{'header__is-alert': !!alert}">
        <v-button class="button_type_static button_size_large button_color_black d--sm--none mobileSideBar__button" @click="mobile_openSidebar">
            <span></span>
            <span></span>
            <span></span>
        </v-button>

        <div class="header__left">
            <router-link :to="{name: 'dashboard'}" class="header__name" > {{user.company_name}} </router-link>
            <v-status :value="daily" v-if="daily && perm.payment_index_management" size="small" @init="myEventHandler" />
        </div>
        <div class="header__tools-hider" :class="{'header__tools-hider_active':tools}" v-click-outside="mobile_click_out">
            <div class="header__tools">
                <v-telList @click="mobile_close_tools" v-if="perm.telephony_access_to_call_management"/>
                <v-company @click="mobile_close_tools" />
                <v-search @click="mobile_close_tools" v-if="perm.quick_search_driver_management"/>
                <v-trans @click="mobile_close_tools" v-if="perm.quick_transaction_button_management"/>
                <v-pay @click="mobile_close_tools" v-if="perm.quick_payment_button_management" />
<!--                <v-chat @click="mobile_close_tools" v-if="perm.quick_chat_management"/>-->
                <v-new-chat @click="mobile_close_tools" v-if="perm.quick_chat_management"/>

            </div>
        </div>
        
        <v-user v-if="user && perm" :name="user.name" :perm="perm"/>
        <button class="header-button__angle" @click="mobile_trigger_tools">
            <svg aria-hidden="true" width="12" height="12">
                <use href="#icon-angle-down"></use>
            </svg>
        </button>

        <!-- <v-user-status @update="HandlerStatusUpdate($event)" v-if="perm.quick_change_status_management"/> -->

        <p v-if="alert" class="header__alert" @click="alert = false"> {{ alert }} </p>
    </div>
</template>

<script> 
import api from '@api' 
import { eventBus } from '@eventBus'
import { mapState, mapActions } from 'vuex'

import chatsocket from './socket'
import telSocket from './socket_tyelephony'
import socket_table from './socket_table'
import telListSocket from './socket_telList'

import storeReset from '../../router/views/storeReset'

import vCompany from './modules/Company'
import vSearch from './modules/HeaderQuickSearch'
import vTrans from './modules/HeaderTransactions'
import vPay from './modules/HeaderQuickPay'
import vChat from './modules/HeaderChatNotification'
import vNewChat from './modules/HeaderNewChatButton'
import vTelList from './modules/HeaderTelList'

import vUser from './modules/HeaderUser'
import vUserStatus from './modules/HeaderUserStatus'

import vStatus from '../../router/views/payments/modules/status'
import vButton from '@components/global/vButton';
import mobile from './mixin/mobile'

// import sockets from './sockets'

export default {
    name:'vHeader',
    components: {
        vChat,
        vNewChat,
        vUser,
        vUserStatus,
        vPay,
        vTrans,
        vSearch,
        vCompany,
        vButton,
        vStatus,
        vTelList
    },
    props: {
        alert: {
            type: [String, Boolean],
            default: false
        }
    },
    computed: {
        ...mapState({
            user: state => state.profile.user,
            perm: state => state.profile.perm
        }),

        
    },
    mixins: [chatsocket,storeReset,telSocket, socket_table, mobile, telListSocket],
    data() {
        return {
            status: [],
            userMenu: [],
            isEndCall: false,
            daily: null,
            timer: null,
        }
    },
    destroyed() {
        window.removeEventListener("resize", this.myEventHandler);
    }, 
    mounted() {
        window.addEventListener("resize", this.myEventHandler);
        window.dispatchEvent(new Event('resize'));
        
        
        eventBus.$on('readyReport', this.socketReadyReport);
        eventBus.$on('errorReport', this.socketerrorReport);
        this.getRef()
        this.initStatus()
    },
    methods: {
        ...mapActions([
            'GET_REFRENCES',
            'UPDATE_PROFILE'
        ]),
        socketReadyReport(e) {
            this.$toast.success(e.message)
        },
        socketerrorReport(e) {
            this.$toast.error(e.message)
        },
        HandlerStatusUpdate(status) {
            this.UPDATE_PROFILE({status})
        }, 
        
        getRef() {
            this.GET_REFRENCES().then(response=>{
                // this.chat_initSocket()
                this.tel_initSocket()
                this.tab_initSocket()
                if(this.perm.telephony_access_to_call_management) this.telList_initSocket()
            }).catch(error=>{
                console.error(error);
                if(error.code == 401) {
                    eventBus.$emit('globalLogout')  
                } 
            })
        },
        initStatus() { 
            const _this = this
            _this.getSummary().then(res=>{
                _this.daily = res.daily
            }) 

            this.timer = setInterval(function() {
                _this.getSummary().then(res=>{
                    _this.daily = res.daily
                }) 
            }, 20000);
        },
        getSummary(payload) {
            this.isloading = false
            return api.payments.summary(payload).then(response=>{
                return response
            }).catch(error=>{
                this.$toast.error(error.message)
                if(this.timer) clearInterval(this.timer)
            }).finally(e=>{
                this.myEventHandler()
                this.isloading = false
            })
        },
        myEventHandler(e) {
            if(this.headerHeight != this.$el.clientHeight) {
                this.headerHeight = this.$el.clientHeight
                this.$emit('headerHeightChange',this.headerHeight)
            }
        },
        
    },
}
</script>
